import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: auto;
`;
export const Title = styled.h2`
  color: #333;
  font-size: 18px;
  margin-bottom: 10px;
  text-align: center;
`;
export const PhoneNumber = styled.p`
  color: #555;
  font-size: 14px;
  margin-bottom: 20px;
`;
export const DegistirButtonWrapper = styled.div`
  background-color: white;
  color: black;

  button {
    font-weight: 700;
    background-color: white;
    color: black;
    font-size: 18px;
    width: 120px;
    height: 32px;
    top: 2px;
    left: 449.31px;
    padding: 4px 16px 4px 16px;
    gap: 10px;
    border-radius: 6px;
    border: 1px solid #999999;
  }
`;

export const OtpWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`;
export const OtpInput = styled.input`
  width: 48px;
  height: 48px;
  font-size: 18px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 12px !important;
  outline: none;
  color: #333333;
  @media screen and (max-width: 900px) {
    width: 36px;
    font-size: 16px;
    height: 36px;
  }
  &:focus {
    border-color: #007c92;
  }
`;
export const Timer = styled.p`
  color: #e60000;
  font-size: 14px;
  margin-bottom: 20px;
`;
export const SubmitButton = styled.button`
  background-color: #e60000;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;
